// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  NAME: 'common.dataView.name',
  DESCRIPTION: 'common.description',
  COLOR: 'common.color',
  PALETTE: 'common.palette',
  GRADIENT: 'common.gradient',
  FONT_DISPLAY: 'common.fontDisplay',
  GRADIENT_REVERSE: 'common.gradient.reverse',
  SYMBOL_SIZE_RANGE: 'common.symbol.size.range',
  IMAGE_SIZE_RANGE: 'common.image.size.range',
  QUERY_EXECUTION_STRATEGY: 'common.query.execution',
  ATTRIBUTE_CLIPBOARD_EXPANDED: 'common.attributeClipboard.expanded',
  SPATIAL_FILTER_MODE: 'common.spatialFilter.mode',
  SELECTION_ENABLED: 'common.selection.enabled',
  SELECTION_CONTEXT_MENU_ENABLED: 'common.selection.contextMenu.enabled',
  SELECTION_ONE_CLICK_FILTERING_ENABLED: 'common.selection.oneClickFiltering.enabled',
  ANALYSIS_CONTEXT_FILTER_ACTIVE: 'analysis.context.filter.active',
  ROW_COUNT_LIMIT: 'common.row.count.limit'
} as const;

/** @see net/disy/cadenza/workbook/model/CommonDataViewSettingsKey.java */
export type CommonDataViewSettingsKey = keyof typeof COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const CommonDataViewSettingsKey = {
  values: Object.keys(COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly CommonDataViewSettingsKey[],
  toPersistenceKey: (value: CommonDataViewSettingsKey) => COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = CommonDataViewSettingsKey.values.find(key => COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No CommonDataViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  }
} as const;

// </GENERATED-CODE>
